/* ═══════════════════════════════════════════════════════════
   tessara-analytics.js — window.tessara.track() helper.
   Fans out to GA4 (via dataLayer) and Plausible if loaded.
   Consent guard: set window.tessara.consent = 'denied' from a
   cookie banner to suppress all events.
   ═══════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  window.tessara = window.tessara || {};
  if (window.tessara.consent === undefined) {
    window.tessara.consent = 'granted';
  }

  window.tessara.track = function (eventName, params) {
    if (window.tessara.consent !== 'granted') return;

    var payload = Object.assign({}, params);

    try {
      if (window.dataLayer) {
        window.dataLayer.push(Object.assign({ event: eventName }, payload));
      }
      if (typeof window.plausible === 'function') {
        window.plausible(eventName, { props: payload });
      }
    } catch (e) {
      // never surface analytics errors to the user
    }
  };

  document.body.classList.add('js');
})();
